import { inject, Injectable } from '@angular/core';
import { ServicesService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class PreferenceEndpointService {
  readonly #service = inject(ServicesService);

  getPreferences() {
    return this.#service.userService('preferences/arrangement');
  }

  setPreferenceForMethod(methodSlug: string) {
    return this.#service.userService(`preferences/method/${methodSlug}`);
  }

  deletePreferenceForMethod(methodSlug: string) {
    return this.#service.userService(`preferences/method/${methodSlug}`);
  }

  arrangementPreferenceForMethod(methodSlug: string, arrangementCode: string) {
    return this.#service.userService(
      `preferences/method/${methodSlug}/arrangement/${arrangementCode}`,
    );
  }
}
